export default __webpack_public_path__ + "static/Abstract-cb6ca17831b91667e407d2b96233c5dd.mp4";